var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('context-view',{attrs:{"visible":_vm.contextViewVisible}}),(!_vm.languageIsChanging)?_c('router-view'):_vm._e(),(_vm.languageIsChanging)?_c('div',{staticClass:"alert alert-info",staticStyle:{"display":"none"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }